import { render, staticRenderFns } from "./LiveFit.vue?vue&type=template&id=52efaceb"
import script from "./LiveFit.vue?vue&type=script&lang=js"
export * from "./LiveFit.vue?vue&type=script&lang=js"
import style0 from "./LiveFit.vue?vue&type=style&index=0&id=52efaceb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports